import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import './PortRestrictions.scss';
import { CheckDiffText } from '../../common/utils';

const PortRestrictionsApproval = ({
    originalValues = {}, changedValues = {}, onApprove, onReject, 
}) => (
    <div className="port-restrictions-block">
        <div className='port-restrictions'>
            <div className='list'>
                <div className='item'>
                    <div>Max Draft, m:</div>
                    <CheckDiffText
                        oldValue={originalValues.maxDraught}
                        newValue={changedValues.maxDraught}
                    />
                </div>
                <div className='item'>
                    <div>Max Beam, m:</div>
                    <CheckDiffText
                        oldValue={originalValues.maxBeam}
                        newValue={changedValues.maxBeam}
                    />
                </div>
                <div className='item'>
                    <div>Max LOA, m:</div>
                    <CheckDiffText
                        oldValue={originalValues.maxLOA}
                        newValue={changedValues.maxLOA}
                    />
                </div>
                <div className='item'>
                    <div>Max DWT, mt:</div>
                    <CheckDiffText
                        oldValue={originalValues.maxDWT}
                        newValue={changedValues.maxDWT}
                    />
                </div>
                <div className='item'>
                    <div>Channel Depth, m:</div>
                    <CheckDiffText
                        oldValue={originalValues.channelDepth}
                        newValue={changedValues.channelDepth}
                    />
                </div>
                <div className='item'>
                    <div>Anchorage Depth, m:</div>
                    <CheckDiffText
                        oldValue={originalValues.anchorageDepth}
                        newValue={changedValues.anchorageDepth}
                    />
                </div>
                <div className='item'>
                    <div>Mean Tide, m:</div>
                    <CheckDiffText
                        oldValue={originalValues.meanTide}
                        newValue={changedValues.meanTide}
                    />
                </div>
            </div>
        </div>
        <div className="form-actions">
            <RaisedButton
                label="Approve"
                primary
                onClick={() => onApprove('portLimitations')}
            />
            <RaisedButton
                label="Reject"
                secondary
                onClick={() => onReject('portLimitations')}
            />
        </div>
    </div>
);

PortRestrictionsApproval.propTypes = {
    originalValues: PropTypes.object.isRequired,
    changedValues: PropTypes.object.isRequired,
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

export default PortRestrictionsApproval;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsApproval.jsx